import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_layout/settings/_panel/workspace/approval-flows/$policyId/",
)({
  component: Empty,
})

function Empty(): React.ReactElement {
  return <span />
}
